(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
if (!customElements.get('ip-collection-load-more')) {
  customElements.define('ip-collection-load-more', class extends HTMLElement {
    connectedCallback() {
      this.onClick = this.loadNext.bind(this);
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.enhance());
      this.observer.observe(this, { childList: true });
      this.enhance();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.observer.disconnect();
      this.controller?.abort();
    }

    enhance() {
      const link = this.querySelector('[data-load-more]');
      const fallback = this.querySelector('[data-load-more-fallback]');
      if (this.activeLink && this.activeLink !== link) {
        this.controller?.abort();
        this.activeLink = null;
        this.loading = false;
      }
      if (link) link.hidden = false;
      if (fallback) fallback.hidden = true;
    }

    async loadNext(event) {
      const link = event.target.closest('[data-load-more]');
      if (!link || !this.contains(link) || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      const section = this.closest('.shopify-section');
      const grid = section.querySelector('.collection-listing .product-grid');
      if (this.loading || !grid || section.querySelector('.ajax-loading')) return;
      this.loading = true;
      const controller = new AbortController();
      this.controller = controller;
      this.activeLink = link;
      const pageUrl = location.href;
      const status = this.querySelector('[data-load-more-status]');
      const label = link.textContent;
      const nextUrl = new URL(link.href, location.href);
      nextUrl.searchParams.set('section_id', this.dataset.sectionId);
      link.setAttribute('aria-disabled', 'true');
      link.setAttribute('aria-busy', 'true');
      link.textContent = status.dataset.loading;
      status.textContent = '';
      const timeout = setTimeout(() => controller.abort(), 15000);

      try {
        const response = await fetch(nextUrl.href, { signal: controller.signal });
        if (!response.ok) throw new Error('The next product page could not be loaded.');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected || location.href !== pageUrl || this.querySelector('[data-load-more]') !== link || section.querySelector('.collection-listing .product-grid') !== grid || section.querySelector('.ajax-loading')) return;
        const incomingSection = html.getElementById(section.id);
        const incomingGrid = incomingSection?.querySelector('.collection-listing .product-grid');
        const incomingControls = incomingSection?.querySelector('ip-collection-load-more');
        if (!incomingGrid || !incomingGrid.children.length || !incomingControls) throw new Error('The next product page was incomplete.');
        const cards = Array.from(incomingGrid.children);
        const firstNewCard = cards[0];
        grid.append(...cards);
        this.innerHTML = incomingControls.innerHTML;
        this.enhance();
        const nextLink = this.querySelector('[data-load-more]');
        const newStatus = this.querySelector('[data-load-more-status]');
        newStatus.textContent = nextLink ? newStatus.dataset.loaded.replace('[count]', cards.length) : newStatus.dataset.complete;
        if (document.activeElement === document.body || document.activeElement === link) {
          const firstLink = firstNewCard.querySelector('a[href]');
          firstLink?.focus({ preventScroll: true });
        }
      } catch (error) {
        if (this.isConnected && location.href === pageUrl && this.querySelector('[data-load-more]') === link) status.textContent = status.dataset.error;
      } finally {
        clearTimeout(timeout);
        if (this.controller === controller) {
          this.loading = false;
          this.activeLink = null;
        }
        if (this.querySelector('[data-load-more]') === link) {
          link.removeAttribute('aria-disabled');
          link.removeAttribute('aria-busy');
          link.textContent = label;
        }
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
